'use client'

import { Section } from '@/components/Section'
import { MicaComplianceTable } from './MicaComplianceTable'
import { MicaIndicatorObject } from './mica'

export function MicaIndicatorsClient({
  micaIndicators,
  className,
}: {
  micaIndicators: MicaIndicatorObject
  className?: string
}) {
  return (
    <Section bgClassName="bg-paper-2" className={className}>
      <MicaComplianceTable micaIndicators={micaIndicators} />
    </Section>
  )
}
